export enum UserRole {
  ADMIN = "admin",
  SUPER_ADMIN = "super_admin",
  CLIENT_MANAGER = "client_manager",
  CLIENT_USER = "client_user",
  VENDOR_OPERATOR = "vendor_operator",
  UNAUTHORIZED = "unauthorized",
}
